import { Injectable } from '@angular/core';
import {
  ContactAliasViewModel,
  ContactPersonViewModel,
  getPersonFullName,
  NewContactViewModel,
  ParticipantSpec,
} from '@fsx/fsx-shared';

@Injectable({
  providedIn: 'root',
})
export class PersonFormService {
  public setPersonName(
    contact: NewContactViewModel | ContactAliasViewModel
  ): void {
    if (
      contact.person?.personalName &&
      !contact.person?.personalName.givenName
    ) {
      contact.person.personalName.givenName = '';
    }
    if (contact.person?.personalName && !contact.person?.personalName.surName) {
      contact.person.personalName.surName = '';
    }
  }

  public getPersonNameFromFilingProfile(
    contactPerson: ContactPersonViewModel | null | undefined,
    participantSpec: ParticipantSpec
  ): ContactPersonViewModel {
    const newContactPerson: ContactPersonViewModel = {
      dateOfBirth: null,
      dateOfDeath: null,
      personalName: {
        prefix: participantSpec?.person?.personalName?.prefix
          ? contactPerson?.personalName.prefix
          : null,
        givenName: participantSpec?.person?.personalName?.givenName
          ? contactPerson?.personalName.givenName
          : null,
        middleName: participantSpec?.person?.personalName?.middleName
          ? contactPerson?.personalName.middleName
          : null,
        surName: participantSpec?.person?.personalName?.surName
          ? contactPerson?.personalName.surName
          : null,
        suffix: participantSpec?.person?.personalName?.suffix
          ? contactPerson?.personalName.suffix
          : null,
        fullName: contactPerson?.personalName.fullName?.length
          ? contactPerson?.personalName.fullName
          : getPersonFullName(contactPerson?.personalName),
      },
    } as unknown as ContactPersonViewModel;
    return newContactPerson;
  }
}
